export default __webpack_public_path__ + "static/media/expandMore.e7c982db.svg";